import React from 'react';
import {useNavigate, useMatch} from 'react-router-dom';
import ChekinProSettings from 'ChekinProSettings';
import {AUTH_INIT_MODELS} from '@guestapp/sdk';
import {PATHS} from 'Routes';
import {HOUSING_ID_KEY, HOST_ID_KEY} from 'utils/constants';
import {useChekinSDK} from 'context/ChekinSDK';
import {usePath} from 'hooks';
import {LocalStorage} from '@guestapp/core';

function useUniversalLink() {
  const {objectId, link, mainToken, modelName} = useChekinSDK();

  const navigate = useNavigate();
  const {getFullPath} = usePath();
  const isHomeView = useMatch('/:token');

  React.useEffect(
    function handleIsUniversalLinkForSearchReservations() {
      let housingId;
      let userId;

      if (modelName === AUTH_INIT_MODELS.housing) {
        housingId = LocalStorage.get(HOUSING_ID_KEY) || objectId;
        LocalStorage.set(HOUSING_ID_KEY, housingId);
      }
      if (modelName === AUTH_INIT_MODELS.user) {
        userId = LocalStorage.get(HOST_ID_KEY) || objectId;
        LocalStorage.set(HOST_ID_KEY, userId);
      }

      if ((housingId || userId) && isHomeView && !ChekinProSettings.isSDK) {
        LocalStorage.set(HOUSING_ID_KEY, housingId);
        navigate(getFullPath(PATHS.searchReservation.main), {
          replace: true,
        });
      }
    },
    [getFullPath, link, mainToken, modelName, objectId, navigate, isHomeView],
  );
}

export {useUniversalLink};
